import React from "react"
import { PageSections } from "../../../../types/routes"
import ListItemContent from "./components/ListItemContent"
import SubList from "./components/SubList"

type Props = {
  children: React.ReactNode
  section: PageSections
  onClick: () => void
  isOpen: boolean
}

const ListItem = ({ children, section, onClick, isOpen }: Props) => {
  return (
    <>
      <li className={`cursor-pointer`} onClick={onClick}>
        <ListItemContent isOpen={isOpen}>{children}</ListItemContent>
      </li>
      <SubList isOpen={isOpen} section={section} />
    </>
  )
}

export default ListItem
